function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
        (event.target === container || event.target === first) &&
        event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {

    this.filterFact = this.querySelector("#filter-facts");
    if(this.filterFact) return;

    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));

  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }



    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.header = this.header || document.getElementById('shopify-section-header');
    this.mainSummary = this.querySelector('#Summary-menu-drawer');
    this.mainSummary.addEventListener('click', this.closeMenuDrawer.bind(this));
    document.getElementById('menu-drawer-close').addEventListener('click', this.closeMenuDrawer.bind(this));

    // menu drawer
    this.drawerMenuHandle = this.querySelectorAll(".menu-drawer__link");
    this.drawerMenuHandle.forEach(link => {
      link.addEventListener('click', this.contentMenuDrawer.bind(this));
    });
  }

  contentMenuDrawer(event) {
    event.preventDefault();

    let targetURL = event.currentTarget,
        targetAttribute = targetURL.getAttribute("data-menu-drawer-target"),
        targetElement = document.getElementById(targetAttribute);

    if (!event.target.classList.contains('has-active')) {
      this.drawerMenuHandle.forEach(link => {
        link.classList.remove('has-active')
      });
      document.querySelectorAll('.menu-drawer__navigation').forEach( event => {
        if(!event.classList.contains(targetAttribute)){
          event.style.display = 'none';
        }
      });
    }

    if (targetElement) {
      targetElement.style.display = 'block';
    }
    targetURL.classList.add('has-active');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.mainSummary.setAttribute('aria-expanded', false);
    this.header.classList.remove('menu-open');
    document.body.classList.remove('overflow-hidden-undefined');
    document.body.classList.remove('hamburg-menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    let getValueName = e.target;
    getValueName.closest("fieldset").querySelector("#variant-change").innerHTML = getValueName.value
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    //console.log(this.closest('.featured-product').querySelector('.product-main-slider'));

    let carouselID = this.closest('.product').querySelector('.product-main-slider');
    let thumbnailsID = this.closest('.product').querySelector('.Slider-Thumbnails-wrap');

    let arrowMainbNext = document.querySelector('[id^="swiper-main-next-"]');
    let arrowMainbPrev = document.querySelector('[id^="swiper-main-prev-"]');

    let arrowThumbNext = document.querySelector('[id^="swiper-button-next-"]');
    let arrowThumbPrev = document.querySelector('[id^="swiper-button-prev-"]');

    let slideMode = thumbnailsID.getAttribute('data-slide-mode');
    if(slideMode){
      let slideMode = false
    }

    let thumbnails = new Swiper(thumbnailsID, {
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: {
        nextEl: arrowThumbNext,
        prevEl: arrowThumbPrev,
      },
      breakpoints: {
        0: {
          direction: 'horizontal',
        },
        768: {
          direction: slideMode === 'vertical' ? 'vertical' :'horizontal',
          slidesPerView: 5
        }
      }
    });
    let carousel = new Swiper(carouselID, {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 30,
      grabCursor: true,
      thumbs: {
        swiper: thumbnails,
      },
      navigation: {
        nextEl: arrowMainbNext,
        prevEl: arrowMainbPrev,
      }
    });


    console.log(this.currentVariant.featured_media.position - 1)

    carousel.slideTo(this.currentVariant.featured_media.position - 1);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, .quick-veiew-js, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `price-${this.dataset.section}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
          if (source && destination) destination.innerHTML = source.innerHTML;
          const price = document.getElementById(`price-${this.dataset.section}`);
          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

//Main sliders
//Slideshow slider methods
let _mainSliderInstance = null;
class SlideshowSlider {

  constructor(selector, options) {
    this.sliderEl = document.getElementById(selector);
    this.options = options || null;
  }

  // Initial swiper slider
  init() {
    _mainSliderInstance = new Swiper(this.sliderEl, this.config());

    //Goto slide to last
    if(this.options && this.options.isSlideToLast) {
      setTimeout(()=>{ this.slideToLast(); })
    }
  }

// Stop method of the swiper slider
  stop() {
    _mainSliderInstance.autoplay.stop();
  }

//Go to(slideTo) method of the swiper slider
  slideTo() {
    let slideTo = this.options.slideTo;
    // When theme slide loop settings on
    if(!!window.isInfinite) slideTo +=1;
    _mainSliderInstance.slideTo(slideTo);

    if(this.options.isPause) {
      _mainSliderInstance.autoplay.stop();
    }
  }

//Start method of the swiper slider
  start() {
    _mainSliderInstance.autoplay.start();
  }

//Go to last(slideTo) method of the swiper slider
  slideToLast() {
    _mainSliderInstance.slideTo(_mainSliderInstance.realIndex+1);
  }

// Configure method of the swiper slider
  config() {
    let autoplay = this.sliderEl.getAttribute('data-slideshow-autoplay'),
        infinite = this.sliderEl.getAttribute('data-slideshow-infinite'),
        arrows = this.sliderEl.getAttribute('data-slideshow-arrows'),
        dots = this.sliderEl.getAttribute('data-slideshow-dots');

    window.isInfinite = !!(infinite === 'true');
    const isEditorMode = !!(Shopify && Shopify.editorDomain);

    let sliderConfig = {
      loop: !!(infinite === 'true'),
      //       effect: 'fade',
      //       fadeEffect: {
      //         crossFade: true
      //       },
    };

    if(autoplay === 'true' && !isEditorMode) {
      sliderConfig.autoplay = { delay: 5000, disableOnInteraction: false};
    }

    if(arrows === 'true') {
      sliderConfig.navigation = { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", };
    }

    if(dots === 'true') {
      sliderConfig.pagination = {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          var zero = '';
          if (index < 9){
            var zero = 0;
          }
          return '<span class="swiper-pagination-fix pagination-'+(index + 1) + ' ' + className + '">' + zero + (index + 1) + "</span>";
        }
      }
    }
    return sliderConfig;
  }
}

class SlideshowSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[id^="Slideshow-"]');
    this.init();

    setTimeout(()=>{
      if(_mainSliderInstance) _mainSliderInstance.destroy(false, false);
      this.init();
    });
  }

  init(){
    let sectionId = this.container.getAttribute('data-section-id'),
        slideShowSlider = new SlideshowSlider('Slideshow-' + sectionId);

    // Initial the slide show slider.

    slideShowSlider.init();
  }
}

customElements.define('slideshow-slider-component', SlideshowSliderComponent);

class QuotesComponent extends HTMLElement {
  constructor() {
    super();
    this.quote = this.querySelector('[id^="Quote-"]');

    if(!this.quote) return;
    this.init();
  }
  init(){
    var quote = new Swiper(this.quote, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
    });
  }
}
customElements.define( 'quotes-component', QuotesComponent);

class ProductSlider extends HTMLElement{
  constructor() {
    super();
    this.carousel = this.querySelector('[id^="Product-Slider-1-"]');
    this.thumbnails = this.querySelector('[id^="galleryThumbnails-"]');

    this.arrowMainbNext = this.querySelector('[id^="swiper-main-next-"]');
    this.arrowMainbPrev = this.querySelector('[id^="swiper-main-prev-"]');

    this.arrowThumbNext = this.querySelector('[id^="swiper-button-next-"]');
    this.arrowThumbPrev = this.querySelector('[id^="swiper-button-prev-"]');

    this.slideMode = this.thumbnails.getAttribute('data-slide-mode');
    this.init();
  }

  init(){

    if (this.thumbnails){
      var thumbnails = new Swiper(this.thumbnails, {
        spaceBetween: 10,
        slidesPerView: 3,
        navigation: {
          nextEl: this.arrowThumbNext,
          prevEl: this.arrowThumbPrev,
        },
        breakpoints: {
          0: {
            direction: 'horizontal',
          },
          768: {
            direction: this.slideMode === 'vertical' ? 'vertical' :'horizontal',
            slidesPerView: 5
          }
        }
      });
    }else{
      var thumbnails = false
    }
    var carousel = new Swiper(this.carousel, {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 30,
      grabCursor: true,
      thumbs: {
        swiper: thumbnails,
      },
      navigation: {
        nextEl: this.arrowMainbNext,
        prevEl: this.arrowMainbPrev,
      }
    });
  }
}
customElements.define('product-slider', ProductSlider);

class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector('[id^="product-carousel-"]');

    if(!this.carousel) return;

    this.column = this.carousel.getAttribute("data-column");
    this.columnMinus = this.carousel.getAttribute("data-column-minus");
    this.columnType = this.carousel.getAttribute("data-type");

    this.columnTablet = (this.column < 3) ? this.column : 3;

    if(this.columnType == 'collection-list') {
      this.columnTablet = (this.column < 2) ? this.column : 2;
    }

    if (this.columnMinus){
      this.column = this.column - this.columnMinus;
      this.columnTablet = this.columnTablet - this.columnMinus;
    }

    this.pagination = this.querySelector('[id^="swiper-pagination-"]');
    this.prev = this.querySelector('[id^="swiper-button-prev-"]');
    this.next = this.querySelector('[id^="swiper-button-next-"]');
    this.init();
  }

  init(){
    var carousel = new Swiper(this.carousel, {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      pagination: {
        el: this.pagination,
        clickable: true
      },
      breakpoints: {
        640: {
          slidesPerView: 2
        },
        750: {
          slidesPerView: this.columnTablet
        },
        990: {
          slidesPerView: this.column
        }
      }
    });
  }
}
customElements.define('carousel-component', CarouselComponent);

class FeaturedCollectionTab extends HTMLElement {
  constructor() {
    super();
    const getEl = this.querySelectorAll(".featured-collection-item");

    getEl.forEach( (el) => {
      el.addEventListener( 'click', event => {
        event.preventDefault();

        let targetEl = event.currentTarget,
            targetId = targetEl.getAttribute("href");

        getEl.forEach(el => {
          if ( !el.currentTarget ) {
            el.classList.remove('has-active');
            let targetId = el.getAttribute("href");
            this.querySelector(targetId).classList.remove('has-active');
          }
        });

        if ( event.currentTarget ){
          targetEl.classList.add("has-active");
          this.querySelector(targetId).classList.add('has-active');
        }
      })
    })
  }

}
customElements.define('featured-collection-tab', FeaturedCollectionTab);

function getCartUpdate(parsedState){
  // cart count
  if(parsedState.item_count == 0){
    document.querySelector('.cart-count-bubble').classList.add('hidden');
  }
  var cartCount = document.querySelector(".cart-count");
  cartCount.innerHTML = parsedState.item_count;
}

// Cart drawer
function getCartFetch(){
  fetch("/cart.json", {
    method: "GET",
    headers: {
      "Accept": "application/json"
    }
  }).then((cartInfo) => cartInfo.json())
      .then((cartInfo) => {
        getCartUpdate(cartInfo)
      })

}

class miniCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('mini-cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('mini-cart-remove-button', miniCartRemoveButton);
const cartDefaults = {
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.drawer__close-btn', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  quantity__button : '.quantity__button', // classname
};


const cartDrawer = document.querySelector(cartDefaults.cartDrawer);
const cartDrawerContent = document.querySelector(cartDefaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(cartDefaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(cartDefaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(cartDefaults.cartOverlay);
const quantity__button = document.querySelector(cartDefaults.quantity__button);

const htmlSelector = document.documentElement;

function openCartDrawer() {
  cartDrawer.classList.add('drawer--is-visible');
  //get cart update
  getCartFetch()
}
function closeCartDrawer() {
  cartDrawer.classList.remove('drawer--is-visible');
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}
function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

if( cartDrawerTrigger !== null || cartDrawerClose !== null || cartOverlay !== null ) {
  cartDrawerTrigger.addEventListener('click', function(event) {
    event.preventDefault();
    openCartDrawer();
    openCartOverlay();
  });
  cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
  });

  cartOverlay.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
  });
}


class miniCartItems extends HTMLElement {
  constructor() {
    super();
    const cartDefaults = {
      cartDrawer: '.js-ajax-cart-drawer', // classname
      cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
      cartDrawerClose: '.drawer__close-btn', // classname
      cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
      cartOverlay: '.js-ajax-cart-overlay', // classname
      quantity__button : '.quantity__button', // classname
    };


    const cartDrawer = document.querySelector(cartDefaults.cartDrawer);
    const cartDrawerContent = document.querySelector(cartDefaults.cartDrawerContent);
    const cartDrawerClose = document.querySelector(cartDefaults.cartDrawerClose);
    const cartDrawerTrigger = document.querySelector(cartDefaults.cartDrawerTrigger);
    const cartOverlay = document.querySelector(cartDefaults.cartOverlay);
    const quantity__button = document.querySelector(cartDefaults.quantity__button);

    const htmlSelector = document.documentElement;


    //cartDrawer.addEventListener('click', this.open.bind(this));
    cartDrawerClose.addEventListener('click', this.close.bind(this));

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

  }
  open() {
    const openCart = {
      cartDrawer: '.js-ajax-cart-drawer', // classname
      cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
      cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
      cartOverlay: '.js-ajax-cart-overlay', // classname
    }

    const opencartDrawer = document.querySelector(openCart.cartDrawer);
    const opencartDrawerContent = document.querySelector(openCart.cartDrawerContent);
    const opencartDrawerTrigger = document.querySelector(openCart.cartDrawerTrigger);
    const opencartOverlay = document.querySelector(openCart.cartOverlay);
    const openhtmlSelector = document.documentElement;
    opencartDrawer.classList.add('drawer--is-visible');
    opencartOverlay.classList.add('is-open');
    openhtmlSelector.classList.add('is-locked');

    getCartFetch()
    return false;
  }

  close() {
    const closeCart = {
      cartOverlay: '.js-ajax-cart-overlay', // classname
      cartDrawer: '.js-ajax-cart-drawer', // classname
      cartDrawerClose: '.drawer__close-btn', // classname
    }
    const closecartDrawer = document.querySelector(closeCart.cartDrawer);
    const closecartOverlay = document.querySelector(closeCart.cartOverlay);

    const closehtmlSelector = document.documentElement;
    closecartOverlay.classList.remove('is-open');
    closecartDrawer.classList.remove('drawer--is-visible');
    closehtmlSelector.classList.remove('is-locked');
    return false;
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart-result',
        section: document.getElementById('mini-cart-result').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          if(parsedState.item_count == 0) {
            this.classList.add('is-empty');
            document.getElementById('mini-cart-footer').classList.add('is-empty');
          } else {
            this.classList.remove('is-empty');
            document.getElementById('mini-cart-footer').classList.remove('is-empty');
          }

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
          document.getElementById("cart-count").innerHTML=parsedState.item_count;
          getCartUpdate(parsedState);
          this.disableLoading();

        });
  }
  renderContents(parsedState) {
    fetch(`${routes.cart_url}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = 'mini-cart-result';
          const sourceid = 'mini-cart-result';
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(sourceid);
          const source = html.getElementById(id);
          // if (source && destination) destination.innerHTML = this.getSectionInnerHTML(source.innerHTML, '#mini-cart-result');
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
                this.getSectionInnerHTML(source.innerHTML, section.selector);
          }));
          document.getElementById("cart-count").innerHTML=parsedState.item_count;

          if(parsedState.item_count == 0) {
            this.classList.add('is-empty');
            document.getElementById('mini-cart-footer').classList.add('is-empty');
          } else {
            this.classList.remove('is-empty');
            document.getElementById('mini-cart-footer').classList.remove('is-empty');
          }
          this.open();
        });
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('mini-cart-result').classList.add('cart__items--disabled');
    this.querySelectorAll('.loading-overlay')[line - 1].classList.remove('hidden');
    document.activeElement.blur();
  }

  getCartFetch(){}

  disableLoading() {
    document.getElementById('mini-cart-result').classList.remove('cart__items--disabled');
  }
}

customElements.define('mini-cart-items', miniCartItems);
document.addEventListener('DOMContentLoaded', function() {

});


class productSwatches extends HTMLElement {
  constructor() {
    super();
    let swatch_list = document.querySelectorAll('.color-swatches-variant'),
        active = document.querySelector('.product-card-swatch.active');
    swatch_list.forEach((swatch, index) => {
      swatch.addEventListener('mouseover', function(event) {
        let currentSwatch = swatch;
        [].forEach.call(swatch_list, function(el) {
          el.classList.remove('active');
          event.target.closest(".card-wrapper").querySelectorAll('.product-primary-image')[0].setAttribute('srcset', currentSwatch.dataset.srcset);
        });
        currentSwatch.classList.add('active');
      });
    });
  }
}
customElements.define('product-swatches', productSwatches);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
